(function () {
  var bar = document.querySelector('[data-sticky-cta]');
  if (!bar || !('IntersectionObserver' in window)) return;

  var header = document.querySelector('.guide-article__header');
  var footer = document.querySelector('.guide-article__footer');

  var state = { header: !!header, footer: false };

  function sync() {
    bar.classList.toggle('is-visible', !state.header && !state.footer);
  }

  if (header) {
    new IntersectionObserver(function (entries) {
      state.header = entries[0].isIntersecting;
      sync();
    }).observe(header);
  }

  if (footer) {
    new IntersectionObserver(function (entries) {
      state.footer = entries[0].isIntersecting;
      sync();
    }).observe(footer);
  }

  sync();
})();
